import { create } from 'zustand';
import { Filter } from '@libs/models/common';
import { FacilityTypesListItem } from '@libs/models/facilities';
import { fetchFacilityTypesList } from '@libs/api/facilityTypes';

type InitialState = {
  initialized: boolean;
  loadingList: boolean;
  facilityTypes: FacilityTypesListItem[];
  page: number;
  perPage: number;
  total: number;
  load: (filters?: Filter[], page?: number, perPage?: number) => Promise<void>;
};

export const useFacilityTypesListStore = create<InitialState>()((set) => ({
  initialized: false,
  loadingList: false,
  facilityTypes: [],
  page: 1,
  perPage: 50,
  total: 0,

  load: async (filters, page = 1, perPage = 50) => {
    set({ loadingList: true });
    try {
      const resp = await fetchFacilityTypesList({ filters, page, size: perPage });
      set({
        loadingList: false,
        initialized: true,
        facilityTypes: resp.items,
        page,
        perPage,
        total: resp.totalCount,
      });
    } finally {
      set({ loadingList: false, initialized: true });
    }
  },
}));
